<form-wizard (onStepChanged)="onStepChanged($event)">
  <app-confirm-dialog [openModal]="showModal"></app-confirm-dialog>
  <wizard-step [title]="'Step 1'" [isActive]="true" (onNext)="onStep1Next($event)" [showNext]="step1.showNext">
    <div *ngIf="this.typeOfAudit =='upload' ">
      <h1>Step 1: Import Excel Job File</h1>
      <div>
        <app-alert></app-alert>

        <form #userForm="ngForm" id="userForm">
          <div class="k-widget k-upload k-header k-dropzone">
            <div role="button" class="cvt-primary k-button k-upload-button" aria-label="Select files..." tabindex="0">
              <input #fileItem="ngModel" type="file" autocomplete="off" id="asdffiles" name="asdffiles"
                [(ngModel)]="myFiles" autocomplete="off" accept="*/*" (change)="onFileSelected($event)" />
              <span>Select files...</span>
            </div>
            <ul class="k-upload-files k-reset" *ngIf="selectedFileToUpload">
              <li class="k-file k-file-success" tabindex="-1">

                <div class="k-file-single ng-tns-c13-0">
                  <span class="k-progress ng-trigger ng-trigger-progressState" style="width: 100%; opacity: 0;"></span>
                  <span class="k-file-extension-wrapper ng-tns-c13-0">
                    <span class="k-file-extension">xls</span>
                    <span class="k-file-state"></span>
                  </span>
                  <span class="k-file-name-size-wrapper ng-tns-c13-0">
                    <span class="k-file-name" [title]="selectedFileToUpload" [innerText]="selectedFileToUpload"></span>
                    <span class="k-file-size" [innerText]="uploadFilesize"></span>
                  </span>

                  <div class="ng-tns-c13-0">
                    <strong class="k-upload-status">
                      <button type="button" class="k-button k-upload-action" tabindex="-1"
                        (click)="onRemoveSelectedFile()">
                        <span class="k-icon k-delete k-i-x" aria-label="Remove" title="Remove">
                        </span>
                      </button>
                    </strong>
                  </div>
                </div>
              </li>

            </ul>
          </div>
        </form>
        <div class="upload-stats">
          <div *ngIf="selectedFileToUpload">
            <div class="upload-stats-title">Total Property Count to be Audited: </div><span
              [innerText]="uploadStatistics.TotalPropertyCount"></span>
          </div>
          <div >
            <div class="upload-validation-messages">
              <label *ngIf="validationErrorMessages.length>0 || propertyValidationErrorMessages.length>0" >
                Errors found during Validation:
              </label>
              <ul *ngFor="let item of validationErrorMessages; index as i; ">
                <li>{{item.Message}}</li>
              </ul>
              <div *ngFor="let propVal of propertyValidationErrorMessages; index as i; ">
                <label>Hotel: {{propVal.name}}</label>
                <ul *ngFor="let err of propVal.Error; index as i; ">
                  <li>{{err.Message}}</li>
                </ul>
              </div>

            </div>
          </div>
      </div>
    </div>
    </div>

    <div *ngIf="this.typeOfAudit =='createFromRateAudit' ">
      <h1>Step 1: Create Rate Availability Audit From Rate Audit</h1>
      <div>
        <app-alert></app-alert>
        <form #userForm="ngForm" id="userForm">

          <div class="auditGrid">
            <kendo-grid [data]="view" [pageSize]="state.take" [skip]="state.skip" [sort]="state.sort" [sortable]="true"
              [pageable]="{buttonCount: 5,info:norecords}" [scrollable]="'none'" [selectable]="true"
              (dataStateChange)="dataStateChange($event)" (selectionChange)="selectionChange($event)">
              <kendo-grid-column field="UniversalAuditIDString" title="Audit ID" [width]="100">
                <ng-template kendoGridHeaderTemplate let-column>
                  <span>{{column.title}} </span>&emsp;
                  <img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
                    src="../../../assets/sort-button.png" />
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div class="raui-audit-id">
                    {{ dataItem.QuickAuditID ? dataItem.QuickAuditID : dataItem.UniversalAuditID}}</div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="PickedUpForProcessingString" title="Date Processed" [width]="">
                <ng-template kendoGridHeaderTemplate let-column>
                  <span>{{column.title}}</span>&emsp;
                  <img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
                    src="../../../assets/sort-button.png" />
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span [innerText]="dataItem.PickedUpForProcessing| dateBlank: 'medium' "></span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="CustomerAccountID" title="Customer Account" [width]="">
                <ng-template kendoGridHeaderTemplate let-column>
                  <span>{{column.title}}</span>&emsp;
                  <img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
                    src="../../../assets/sort-button.png" />
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.CustomerAccountID }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="ContractYear" title="Contract Year" [width]="">
                <ng-template kendoGridHeaderTemplate let-column>
                  <span>{{column.title}}</span>&emsp;
                  <img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
                    src="../../../assets/sort-button.png" />
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.ContractYear }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="RACFilters" title="RAC Filters" [width]="">
                <ng-template kendoGridHeaderTemplate let-column>
                  <span>{{column.title}}</span>&emsp;
                  <img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
                    src="../../../assets/sort-button.png" />
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.RACFilters }}
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </form>
      </div>

    </div>
  </wizard-step>
  <wizard-step [title]="'Step 2'" [isActive]="false" (onComplete)="onStep2Next($event)">

    <h1>Step 2: Rate Availability Job Manager</h1>


    <div class="input">

      <div class="leftdiv">
        <table>
          <tr>
            <td>Audit Name
              <label class="asterix">*</label>
            </td>
            <td>
              <input id="name" type="text" [(ngModel)]="AuditName" />
            </td>

            <td>Sabre PCC</td>
            <td>
              <input id="sabrePCC" type="text" [(ngModel)]="SabrePCC" />
            </td>

            <td>Sabre RAC Type</td>
            <td>
              <kendo-dropdownlist class="RACTypeDropdown" [data]="RACTypeOptions" [value]="RACTypeSelection"
                [valuePrimitive]="true" [allowCustom]="false"></kendo-dropdownlist>
            </td>

            <td>Rate Access Code Filters
              <label class="asterix">*</label>
            </td>
            <td>
              <input class="RACFilterText" id="RACFilters" type="text" [(ngModel)]="RACFilters" />
            </td>
          </tr>

        </table>
      </div>

    </div>
    <div class="hotelDiv">
      <div class="gridDiv " id="topmost">
        <div class="titlebar-div" id="titlebar-div">Hotels Selected For Processing </div>
        <div class="auditGrid " id="audit-grid">

          <kendo-grid id="kendoPropertyGrid" [data]="viewProperty" [sort]="stateProperty.sort" [sortable]="true"
            [height]="575" [sortable]="true" [pageSize]="stateProperty.take" [skip]="stateProperty.skip" [autoSize]="true"
            [pageable]="{buttonCount: 5,info:norecords}" (dataStateChange)="dataStateChangeProperty($event)">

            <kendo-grid-column title="" [width]="50">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <ngl-checkbox>
                  <input ngl type="checkbox" [(ngModel)]="dataItem.checked"
                    name="dataItem.AuditPropertyID" />
                </ngl-checkbox>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="NameLowerCase" title="Property Name" [width]="400">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}} </span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div>{{ dataItem.Name }}</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="HotelCRSCode" title="Property CRS Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.HotelCRSCode}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AddressLowerCase" title="Address" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Address }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="City" title="City" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.City }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="StateProvince" title="State/Province" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.StateProvince }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="PostalCode" title="Postal Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.PostalCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AmadeusChainCode" title="Amadeus Chain Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.AmadeusChainCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AmadeusPropCode" title="Amadeus Property Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.AmadeusPropCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ApolloChainCode" title="Apollo Chain Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.ApolloChainCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ApolloPropCode" title="Apollo Property Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.ApolloPropCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="GalileoChainCode" title="Galileo Chain Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.GalileoChainCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="GalileoPropCode" title="Galileo Property Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.GalileoPropCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="SabreChainCode" title="Sabre Chain Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.SabreChainCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="SabrePropCode" title="Sabre Property Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.SabrePropCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="WorldspanChainCode" title="Worldspan Chain Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.SabreChainCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="WorldspanPropCode" title="Worldspan Property Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.WorldspanPropCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CurrencyFormatCode" title="Currency Code" [width]="100">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.CurrencyFormatCode }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season1ExpectedPrice" title="Season1 Expected Price" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season1ExpectedPrice | price:  dataItem.Season1Dynamic : dataItem.Season1Ceiling  }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season1StartDateString" title="Season1 Start Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season1StartDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season1EndDateString" title="Season1 End Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season1EndDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season2ExpectedPrice" title="Season2 Expected Price" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season2ExpectedPrice | price:  dataItem.Season2Dynamic : dataItem.Season2Ceiling  }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season2StartDateString" title="Season2 Start Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season2StartDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season2EndDateString" title="Season2 End Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season2EndDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season3ExpectedPrice" title="Season3 Expected Price" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem >
                {{dataItem.Season3ExpectedPrice | price:  dataItem.Season3Dynamic : dataItem.Season3Ceiling  }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Season3StartDateString" title="Season3 Start Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season3StartDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season3EndDateString" title="Season3 End Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season3EndDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season4ExpectedPrice" title="Season4 Expected Price" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season4ExpectedPrice | price:  dataItem.Season4Dynamic : dataItem.Season4Ceiling  }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season4StartDateString" title="Season4 Start Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season4StartDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season4EndDateString" title="Season4 End Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season4EndDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season5ExpectedPrice" title="Season5 Expected Price" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season5ExpectedPrice | price:  dataItem.Season5Dynamic : dataItem.Season5Ceiling  }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season5StartDateString" title="Season5 Start Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season5StartDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season5EndDateString" title="Season5 End Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season5EndDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season6ExpectedPrice" title="Season6 Expected Price" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season6ExpectedPrice | price:  dataItem.Season6Dynamic : dataItem.Season6Ceiling  }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season6StartDateString" title="Season6 Start Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season6StartDateCST }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Season6EndDateString" title="Season6 End Date" [width]="200">
              <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;
                <img *ngIf="this.sortedProperty !== column.field" style="margin-bottom: -5px;"
                  src="../../../assets/sort-button.png" />
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.Season6EndDateCST }}
              </ng-template>
            </kendo-grid-column>


          </kendo-grid>

        </div>
      </div>
      <div class="rightdiv">
        <div class="titlebar-div" id="titlebar-div">GDS/Rate Code Selection </div>
        <div class="borderDiv">
          <table>
            <tr>
              <td align="center">
                <span class="labelrow"> GDS</span>
              </td>
              <td align="center">
                <span class="labelrow">Rate Access Code</span>
              </td>
            </tr>
            <tr>
              <td>Amadeus</td>
              <td>
                <input id="Amadeus" type="text" [(ngModel)]="AmadeusRAC" [disabled]="!AuditAmadeus" />
              </td>
            </tr>
            <tr>
              <td>Apollo</td>
              <td>
                <input id="Apollo" type="text" [(ngModel)]="ApolloRAC" [disabled]="!AuditApollo" />
              </td>
            </tr>
            <tr>
              <td>Galileo</td>
              <td>
                <input id="Galileo" type="text" [(ngModel)]="GalileoRAC" [disabled]="!AuditGalileo" />
              </td>
            </tr>
            <tr>
              <td>Sabre</td>
              <td>
                <input id="Sabre" type="text" [(ngModel)]="SabreRAC" [disabled]="!AuditSabre" />
              </td>
            </tr>
            <tr>
              <td>Worldspan</td>
              <td>
                <input id="Worldspan" type="text" [(ngModel)]="WorldspanRAC" [disabled]="!AuditWorldspan" />
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
    <div class="input jobDiv">
      <div class=" jobDivLeft">
        <app-calendar></app-calendar>

      </div>
      <div class=" jobDivRight">
        <div class="titlebar-div" id="titlebar-div">Date Selection Shortcuts </div>
        <div class="borderDiv">

          <label for="DateRange">Audit Date Range</label>

          <kendo-datepicker class="dateSelectionDiv" (valueChange)="onRangeStartDateChange($event)"
            [value]="datePickerStartDate" [min]="minStartRange" [max]="maxStartRange"></kendo-datepicker> -
          <kendo-datepicker class="dateSelectionDiv" (valueChange)="onRangeEndDateChange($event)"
            [value]="datePickerEndDate" [min]="minEndRange" [max]="maxEndRange"></kendo-datepicker>
          <br>

          <table class="dateTable">
            <tr>
              <td>
                <button class="k-button cvt-tertiary dateButton" (click)="onDayClick('Monday')">Monday(s)</button>
              </td>
              <td>
                <button class="k-button cvt-tertiary dateButton" (click)="onDayClick('Tuesday')">Tuesday(s)</button>
              </td>
            </tr>
            <tr>
              <td>
                <button class="k-button cvt-tertiary dateButton" (click)="onDayClick('Wednesday')">Wednesday(s)</button>
              </td>
              <td>
                <button class="k-button cvt-tertiary dateButton" (click)="onDayClick('Thursday')">Thursday(s)</button>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <button class="k-button cvt-tertiary dateButton" (click)="onDayClick('Friday')">Friday(s)</button>
              </td>

            </tr>
            <tr>
              <td>
                <button class="k-button cvt-tertiary dateButton" (click)="onDayClick('Saturday')">Saturday(s)</button>
              </td>
              <td>
                <button class="k-button cvt-tertiary dateButton" (click)="onDayClick('Sunday')">Sunday(s)</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="input jobDiv event">
      <div class="titlebar-div" id="titlebar-div">Schedule Event </div>
      <div class="borderDiv">
        <table>
          <tr>
            <fieldset ngl-radio-group>
              <td>
                <ngl-radio-option label="Run Now">
                  <input ngl type="radio" [checked]="true" (click)="onRunNowClick()" />
                </ngl-radio-option>
                <br>
              </td>
              <td>
                <ngl-radio-option label="Run Later">
                  <input ngl type="radio" (click)="onRunLaterClick()" />
                </ngl-radio-option>
              </td>
            </fieldset>
          </tr>
          <tr>
            <td>
              Date To Schedule Audit
            </td>

            <td>
              <kendo-datepicker [disabled]="runNowisEnabled" [value]="auditDate" (valueChange)="onDateChange($event)"
                [min]="earliestRunDate" [max]="latestRunDate"></kendo-datepicker>
              <br>
              <br>
            </td>
          </tr>
          <tr>
            <td>
              Time To Schedule Audit
            </td>
            <td>
              <kendo-timepicker [disabled]="runNowisEnabled" class="ExtraSpace" [value]="auditTime"
                (valueChange)="onTimeChange($event)"></kendo-timepicker>
                <br>
                <br>
              </td>
          </tr>
          <tr>
          </tr>
          <tr>
            <td class="failedEmailContact">
              <div>
                <label title="">Report Failed Emails To
                  <input id="txtFailedEmailContactEmailAddress" type="text" maxlength=255 [(ngModel)]="AuditContactEmailAddress"
                     />
                </label>
              </div>
            </td>
            <td>
            <div id="notifications">
                <fieldset ngl-radio-group label="Select Audit Notification Template" >
                    <ngl-radio-option label="Do Not Build Notifications Packages">
                  <input ngl type="radio" name="notBuildNotification" [(ngModel)]="buildNotification" [value]="false" [checked]="!buildNotification"
                  />
                </ngl-radio-option>
                  <ngl-radio-option label="Build Notifications Packages">
                  <input ngl type="radio" name="buildNotification" [(ngModel)]="buildNotification" [value]="true" [checked]="buildNotification"
                  />
                </ngl-radio-option>
                  <kendo-dropdownlist #notifTemplate [data]="_notificationTemplateList" [disabled]="!buildNotification" valueField="id" textField="name"
                [(ngModel)]="notificationSelection" [valuePrimitive]="true" [allowCustom]="false"
                  item-width="300">
                  <ng-template  *ngIf="!buildNotification" kendoDropDownListValueTemplate>
                    <span class="setColor">No Assigned Notification Template</span>
                  </ng-template>
                  <ng-template kendoDropDownListItemTemplate let-dataItem>
                    <span>{{dataItem.name}}</span>
                  </ng-template>
                </kendo-dropdownlist>
              </fieldset>
            </div>
          </td>
          </tr>
        </table>
      </div>
    </div>


  </wizard-step>
</form-wizard>
<app-spinner [isBusy]="isBusy"></app-spinner>
